import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, normalizeStyle as _normalizeStyle, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-733dc082"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "E808DRenderContainer"
};
const _hoisted_2 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, " ", -1));
const _hoisted_3 = {
  class: "ft20"
};
const _hoisted_4 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "正三角形表面的颜色，红色表示数字 1，绿色表示数字 2，蓝色表示数学 3，黄色表示数字 4；", -1));
const _hoisted_5 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "正三角形的位置解构：正面的正三角形的数字表达为 1，左侧面的数字表达为 2，右侧面的数字表达为 3，地面的数字表达为 4；", -1));
const _hoisted_6 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "计算正三角体的正面和底面两个正三角形 颜色乘以位置的计算结果之和，填入图形下方输入框中。", -1));
const _hoisted_7 = {
  class: "flex items-center justify-center wd100 mt32 mb32"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_el_col = _resolveComponent("el-col");
  const _component_el_row = _resolveComponent("el-row");
  const _component_E808DTriangle = _resolveComponent("E808DTriangle");
  const _component_el_input = _resolveComponent("el-input");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_el_row, {
    class: "flex items-center justify-center"
  }, {
    default: _withCtx(() => [_createVNode(_component_el_col, {
      span: 8,
      class: "flex items-center justify-center"
    }, {
      default: _withCtx(() => [_hoisted_2]),
      _: 1
    }), _createVNode(_component_el_col, {
      span: 8,
      class: "flex items-center justify-center"
    }, {
      default: _withCtx(() => [_createElementVNode("span", _hoisted_3, "第" + _toDisplayString((($props.data[$props.data.length - 1].questionIndex + 1) / 5).toFixed(0)) + "组", 1)]),
      _: 1
    }), _createVNode(_component_el_col, {
      span: 8,
      class: "flex justify-end items-center"
    }, {
      default: _withCtx(() => [$props.reviewMode ? (_openBlock(), _createElementBlock("span", {
        key: 0,
        style: {
          "background": "#1388ff",
          "color": "white"
        },
        class: "ptr opd6 brd4",
        onClick: _cache[0] || (_cache[0] = $event => _ctx.$router.go(-1))
      }, "结束回看")) : _createCommentVNode("", true)]),
      _: 1
    })]),
    _: 1
  }), _createVNode(_component_el_row, {
    class: "flex flex-col mt16"
  }, {
    default: _withCtx(() => [_hoisted_4, _hoisted_5, _hoisted_6]),
    _: 1
  }), _createElementVNode("div", _hoisted_7, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.data, q => {
    return _openBlock(), _createElementBlock("div", {
      class: "wd20 flex items-center justify-center flex flex-col",
      key: q.questionIndex
    }, [_createVNode(_component_E808DTriangle, {
      colors: q.question
    }, null, 8, ["colors"]), $props.review ? (_openBlock(), _createBlock(_component_el_row, {
      key: 0,
      class: "flex flex-col"
    }, {
      default: _withCtx(() => [_createElementVNode("span", null, "正确答案：" + _toDisplayString(q.rightAnswer), 1), $props.review && $props.review[q.questionIndex] != null ? (_openBlock(), _createElementBlock("span", {
        key: 0,
        style: _normalizeStyle({
          color: $props.review[q.questionIndex].result ? 'green' : 'red'
        })
      }, " 您的答案：" + _toDisplayString($props.review[q.questionIndex].answer), 5)) : _createCommentVNode("", true)]),
      _: 2
    }, 1024)) : (_openBlock(), _createBlock(_component_el_input, {
      key: 1,
      class: "opd12",
      placeholder: "请输入答案",
      onChange: $options.checkAnswer,
      clearable: "",
      type: "number",
      modelValue: $data.values[q.questionIndex],
      "onUpdate:modelValue": $event => $data.values[q.questionIndex] = $event
    }, null, 8, ["onChange", "modelValue", "onUpdate:modelValue"]))]);
  }), 128))])]);
}